import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  AsyncDataItem,
  IShift,
  idleDataItem,
  isError,
  isLoading
} from '@pharvio/core/shared';
import { ClickStopPropagationDirective } from '@pharvio/core/ui';
import { ShiftPaths } from '../../../../core/constants/routes/shifts-routes';
import { WidgetErrorComponent } from '../widget-error/widget-error.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-shift-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    MatIconModule,
    DatePipe,
    WidgetErrorComponent,
    ClickStopPropagationDirective
  ],
  templateUrl: './shift-card.component.html'
})
export class ShiftCardComponent {
  @Input({ required: true }) item: AsyncDataItem<IShift[]> = idleDataItem([]);
  @Output() retry = new EventEmitter<void>();

  protected readonly isLoading = isLoading;
  protected readonly isError = isError;

  readonly linkToOpenShifts = ShiftPaths.List;
}
